import { psImageBaseUri } from "@/api/constants"
export const formattedPSImageUrl = (options: {
	path: string
	size?: string
	extension?: string
}) => {
	const { path, size, extension } = options

	// Remove leading slashes
	let newPath = path.replace(/^\/+/, "")

	if (size || extension) {
		const lastDot = newPath.lastIndexOf(".")
		let base = newPath
		let ext = ""
		if (lastDot !== -1) {
			base = newPath.slice(0, lastDot)
			ext = newPath.slice(lastDot + 1)
		}
		if (size) base += `-${size}`
		if (extension) ext = extension
		newPath = ext ? `${base}.${ext}` : base
	}
	const url = `${psImageBaseUri}/${newPath}`
	return url
}

//The path should have extension and size already applied
export const formattedPSImagePathToUrl = (path: string) => {
	// Remove leading slashes
	path = path.replace(/^\/+/, "")

	// Replace the original host (first component) with prefix
	const pathParts = path.split("/")
	pathParts[0] = "" // remove the original host
	const newPath = pathParts.slice(1).join("/")

	const url = `${psImageBaseUri}/${newPath}`
	return url
}
